import styled, { css } from 'styled-components';

import Tooltip from '../../Tooltip';

interface IContainer{
  isFocused?: boolean;
  isFilled?: boolean;
  isErrored?: boolean;
  readOnly?: boolean;
}

export const WrapperCheck = styled.span`
  label{
    margin-right: 8px;
    span{
      color: var(--color-primary);
      font-weight: 400;
      margin-left: 12px;
    }
  }

  input[type=checkbox] {
      position: relative;
      cursor: pointer;
    }

    input[type=checkbox]:before {
         content: "";
         display: block;
         position: absolute;
         width: 20px;
         height: 20px;
         top: -3px;
         left: 0;
         border: 1px solid var(--color-border);
         border-radius: 2px;
         background-color:#e9e9e9;
      }
    input[type=checkbox]:checked:before {
         content: "";
         display: block;
         position: absolute;
         width: 20px;
         height: 20px;
         top: -3;
         left: 0;
         border: 1px solid var(--color-button);
         border-radius: 2px;
         background-color: var(--color-button);
    }
    input[type=checkbox]:checked:after {
         content: "";
         display: block;
         width: 5px;
         height: 10px;
         border: 1px solid white;
         border-width: 0 2px 2px 0;
         -webkit-transform: rotate(45deg);
         -ms-transform: rotate(45deg);
         transform: rotate(45deg);
         position: absolute;
         top: 0;
         left: 7px;
    }
`;

export const Container = styled.div<IContainer>`
  border-radius: 4px;
  padding: 8px;
  width: 100%;
  border: 1px solid var(--color-border);
  color: var(--color-gray);
  background: var(--color-white);

  ${(props) => props.readOnly && css`
    background: var(--color-bg-disable);
  `}

  position: relative;

  ${(props) => props.isErrored && css`
    border-color: var(--color-red);
  `}

  ${(props) => props.isFocused && css`
    border-color: var(--color-grey);
  `}

  display: flex;
  align-items: center;

  & + div{
      margin-top: 12px;
    }

  input{
    flex: 1;
    background: transparent;
    border: 0;
    color: var(--color-black);

    ${(props) => props.isErrored && css`
      /* padding-right: 28px; */
    `}

    &::placeholder{
      color: #666360;
    }
  }

  span{
      font-size: 14px;
      color: var(--color-red);
      text-align: left;
      /* display: none; */
    }


`;

export const Error = styled(Tooltip)`
  height: 20px;
  top: 8px;
  right: 8px;
  background: #FFF;

  position: absolute;
  display:none;
  visibility: hidden;


  ${(props) => props.title && css`
    display:block;
    visibility: visible;
  `}

  svg{
    margin: 0;
  }

  span {
    background: var(--color-red);
    color: #FFF;

    left: 90%;
    transform: translateX(-95%);

    &::before{
      border-color: var(--color-red) transparent;
      left: 90%;
    }
  }
`;
